var map = {
	"../modules/coverage/coverage.module": [
		"./src/app/modules/coverage/coverage.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"default~modules-coverage-coverage-module~modules-solicitudes-solicitudes-module~modules-users-users-module",
		"default~modules-coverage-coverage-module~modules-siniestro-siniestro-module~modules-users-users-module",
		"default~modules-coverage-coverage-module~modules-home-home-module",
		"modules-coverage-coverage-module"
	],
	"../modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"modules-dashboard-dashboard-module"
	],
	"../modules/siniestro/siniestro.module": [
		"./src/app/modules/siniestro/siniestro.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"default~modules-coverage-coverage-module~modules-siniestro-siniestro-module~modules-users-users-module",
		"modules-siniestro-siniestro-module"
	],
	"../modules/solicitudes/solicitudes.module": [
		"./src/app/modules/solicitudes/solicitudes.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"default~modules-coverage-coverage-module~modules-solicitudes-solicitudes-module~modules-users-users-module",
		"modules-solicitudes-solicitudes-module"
	],
	"../modules/users/users.module": [
		"./src/app/modules/users/users.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"default~modules-coverage-coverage-module~modules-solicitudes-solicitudes-module~modules-users-users-module",
		"default~modules-coverage-coverage-module~modules-siniestro-siniestro-module~modules-users-users-module",
		"modules-users-users-module"
	],
	"./modules/home/home.module": [
		"./src/app/modules/home/home.module.ts",
		"default~modules-coverage-coverage-module~modules-home-home-module",
		"modules-home-home-module"
	],
	"./shell/shell.module": [
		"./src/app/shell/shell.module.ts",
		"default~modules-coverage-coverage-module~modules-dashboard-dashboard-module~modules-siniestro-sinies~be13352f",
		"shell-shell-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;